<template>
    <div id="building">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="reload()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{ title }}
        </h1>
        <img class="imgCard" :src="dataUrl()" alt="SO" />
        <h2>Demandes en cours</h2>
        <div class="container">
            <div v-if="sortedInquiries.length">
                <div class="notifList" v-for="(item, index) in sortedInquiries" :key="index">
                    <button v-on:click="displayYear(index)" class="btnAccordion">
                        <font-awesome-icon v-if="getYear(index)" icon="angle-up" />
                        <font-awesome-icon v-else icon="angle-down" />
                        &nbsp;&nbsp;{{item.year}}
                    </button>
                    <div v-if="!getYear(index)">
                        <div v-for="(itemInq, indexInq) in item.data" :key="indexInq">
                            <div class="divCard">
                                <span class="spanCard">
                                {{ itemInq.fulldate + "  - " }} <b>{{itemInq.name + " - " +itemInq.type}}</b>
                                </span>
                                <div v-if="getStatus(indexInq, index)" id="circleRed"></div>
                                <button class="btnCard" v-on:click="goToInquiryPage(itemInq.name)"><font-awesome-icon icon="chevron-right" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="btnAccordion btnAccordionNone">
                Aucune demande en cours
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Building',
        data() {
            return {
                building : {},
                Name:"ADPR",
                isYearHide: [],
                sortedInquiries: [],
                title: "Batiment",
                filAriane: ""
            };
        },
        methods:{
            displayYear(i){
                var state = !this.isYearHide[i];
                this.isYearHide.splice(i, 1);
                this.isYearHide.splice(i, 0,state);
            },
            goToInquiryPage(name){
                this.$cookie.set('fromPagePrev', "home");
                this.$cookie.set('fromQueryPrev', "");
                this.$cookie.set('fromPage', "building");
                this.$cookie.set('fromQuery', this.$route.query.name);
                this.$router.replace({ name: "inquiry", query: {name: name}  });
            },
            getYear(i){
                return this.isYearHide[i];
            },
            getStatus(j, i){
                if(this.sortedInquiries[i].data[j].status === "facture à payer" || this.sortedInquiries[i].data[j].status === "devis à valider"){
                    return true;
                }
                else{
                    return false;
                }
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "home" });
            },
            dataUrl(){
                if(this.building.picture){
                    return 'data:'+this.building.picture.img.contentType+';base64,' + btoa(
                        new Uint8Array(this.building.picture.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                }
                else{
                    return "/assets/empty.png";
                }
            },
            getCookies: function() {
                this.$cookie.set('currentAriane', "Bien n° " +this.$route.query.name);
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client" || !this.$route.query.name ){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getBuilding(this.$route.query.name);
                }
            },
            getBuilding(name){
                var vm = this;
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                axios.get('https://so.gaviota.fr/api/building/'+name)
                .then(function (response) {
                    if(response.data.building){
                        vm.building = response.data.building;
                        vm.title = vm.building.buildingAddress.streetNb + " " +
                                    vm.building.buildingAddress.streetName+", "+
                                    vm.building.buildingAddress.postalCode + " " +
                                    vm.building.buildingAddress.city;
                        for(var i=0; i<vm.building.inquiry.length; i++){
                            
                            var n = new Date(vm.building.inquiry[i].timestamp*1000);
                            var y = n.getFullYear();
                            var day = "0" + n.getDate();
                            var month = "0" + (n.getMonth() + 1);
                            vm.building.inquiry[i].fulldate=day.substr(-2) + '/' + month.substr(-2) + '/' +y;

                            var yearAlreadyExist = false;

                            if(vm.building.inquiry[i].status ==="cloturée"){
                                y="Afficher les demandes passées"
                            }

                            for(var j=0; j<vm.sortedInquiries.length; j++){
                                if(vm.sortedInquiries[j].year === y){
                                    yearAlreadyExist = true;
                                    if(vm.building.inquiry[i].timestamp > vm.sortedInquiries[j].data[0].timestamp){
                                        vm.sortedInquiries[j].data.unshift(vm.building.inquiry[i]);
                                    }
                                    else{
                                        vm.sortedInquiries[j].data.push(vm.building.inquiry[i]);
                                    }
                                    
                                }
                            }
                            if(!yearAlreadyExist){
                                if(vm.building.inquiry[i].status !=="cloturée"){
                                    if(vm.sortedInquiries.length){
                                        if(vm.sortedInquiries[0].year < y || vm.sortedInquiries[0].year ==="Afficher les demandes passées"){
                                            vm.isYearHide.unshift(false);
                                            vm.sortedInquiries.unshift({year:y, data:[vm.building.inquiry[i]]});
                                        }
                                        else{
                                            vm.isYearHide.push(false);
                                            vm.sortedInquiries.push({year:y, data:[vm.building.inquiry[i]]});
                                        }
                                    }
                                    else{
                                        vm.sortedInquiries.push({year:y, data:[vm.building.inquiry[i]]});
                                    }
                                }
                                else{
                                    vm.isYearHide.push(true);
                                    vm.sortedInquiries.push({year:"Afficher les demandes passées", data:[vm.building.inquiry[i]]});                                                                   
                                }
                            }
                        }
                    }
                    else{
                        this.logout();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #building {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding-bottom: 10px;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
</style>